import React from 'react';
import { usePageMeta } from '../utils/usePageMeta';
import { Eyebrow } from '../components/Eyebrow';

export const InquirePage: React.FC = () => {
  usePageMeta({
    title: 'Inquire About Coffee | Lot 20 Coffee',
    description: 'Send us a specific inquiry about our Kenyan specialty coffees. Ask about availability, pricing, and sample requests.',
    canonicalPath: '/inquire'
  });

  return (
    <>
      {/* Header */}
      <section className="pt-3 pb-16 bg-[#FAFAF8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Eyebrow className="mb-3">Inquiries</Eyebrow>
          <h1 className="font-display text-4xl md:text-5xl text-[#404040] mb-4">
            Coffee Inquiry
          </h1>
          <p className="text-lg text-[#6B6B6B] max-w-2xl">
            Get in touch to learn more about our coffees, request samples, or discuss partnership opportunities.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24 md:pb-32 bg-[#FAFAF8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="border border-[#E8E6E2] p-8 max-w-xl">
            <p className="font-display text-[#6B6B6B] leading-relaxed mb-8">
              For coffee inquiries, please contact us directly:
            </p>
            <div className="space-y-4">
              <div>
                <p className="text-xs uppercase tracking-wider text-[#A3A3A3] mb-1">Email</p>
                <a href="mailto:sidney@lot20.coffee" className="text-[#404040] font-medium hover:text-[#E85C27] transition-colors duration-300">
                  sidney@lot20.coffee
                </a>
              </div>
              <div>
                <p className="text-xs uppercase tracking-wider text-[#A3A3A3] mb-1">Phone</p>
                <a href="tel:+254707054593" className="text-[#404040] font-medium hover:text-[#E85C27] transition-colors duration-300">
                  +254 707 054 593
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
